import { render, staticRenderFns } from "./ShippingLabelTable.vue?vue&type=template&id=5d65faaf&"
import script from "./ShippingLabelTable.vue?vue&type=script&lang=js&"
export * from "./ShippingLabelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports